import React from "react";
import searchStyles from "./scss/search.module.scss";

const SearchBar = () => {
  return (
    <div className={searchStyles.searchBar}>
      <form>
        <div className={searchStyles.searchWrapper}>
          <input
            type="text"
            className="form-control"
            id="search-main"
            name="search_main"
            placeholder="Search"
          />
          <button type="submit">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="#4A4A4A"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.625 16.3125C4.3875 16.3125 0.9375 12.8625 0.9375 8.625C0.9375 4.3875 4.3875 0.9375 8.625 0.9375C12.8625 0.9375 16.3125 4.3875 16.3125 8.625C16.3125 12.8625 12.8625 16.3125 8.625 16.3125ZM8.625 2.0625C5.0025 2.0625 2.0625 5.01 2.0625 8.625C2.0625 12.24 5.0025 15.1875 8.625 15.1875C12.2475 15.1875 15.1875 12.24 15.1875 8.625C15.1875 5.01 12.2475 2.0625 8.625 2.0625Z"
                fill="#4A4A4A"
              ></path>
              <path
                d="M16.5001 17.0625C16.3576 17.0625 16.2151 17.01 16.1026 16.8975L14.6026 15.3975C14.3851 15.18 14.3851 14.82 14.6026 14.6025C14.8201 14.385 15.1801 14.385 15.3976 14.6025L16.8976 16.1025C17.1151 16.32 17.1151 16.68 16.8976 16.8975C16.7851 17.01 16.6426 17.0625 16.5001 17.0625Z"
                fill="#4A4A4A"
              ></path>
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
